<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Dashboard" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <!-- @include('blocks.page-content-header') -->
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />

          <div class="card-with-tab mb-3">
            <div class="">
              <ul class="nav nav-pills">
                <li
                  v-for="tab in upperTabs"
                  v-bind:key="tab.link"
                  class="nav-item"
                >
                  <router-link
                    :to="tab.link"
                    :class="
                      `nav-link ${
                        tab.label == 'REKAPITULASI LAPORAN' ? 'active' : ''
                      }`
                    "
                    >{{ tab.label }}</router-link
                  >
                </li>
              </ul>
            </div>
          </div>
          <div class="row">
            <div class="col-md-2">
              <LeftMenuRl active="rl4" />
            </div>
            <div class="col-md-10">
              <div class="row">
                <div class="col-md-4">
                  <PageContentHeader
                    :data="dataRl"
                    :fromUrl="fromUrl || ''"
                    :fromTab="$route.query.fromTab || ''"
                  />
                </div>
                <div class="col-md-6">
                  <FormRow
                    :row="filters"
                    @handleChange="(e) => handleChange(e)"
                  />
                </div>
                <div class="col-md-2 pl-0">
                  <button class="btn btn-secondary btn-block" @click="apply">
                    Apply
                  </button>
                </div>
              </div>
              <div>
                <b-tabs content-class="mt-3">
                  <b-tab title="RL 4A" active>
                    <div class="card" v-if="loadedA1">
                      <div class="card-body">
                        <div class="row mb-4">
                          <div class="col-md-9">
                            <h4 class="mt-2">
                              Formulir RL 4A Data Keadaan Morbiditas Pasien
                              Rawat Inap Rumah Sakit
                            </h4>
                          </div>
                          <div class="col-md-3 pl-3">
                            <download-excel
                              class="btn btn-default btn-primary btn-block"
                              :data="rl4a"
                              worksheet="RL-4A.1"
                              name="rekapitulasi_laporan_4_a_1"
                            >
                              Download Excel
                            </download-excel>
                          </div>
                        </div>
                        <div
                          style="height: auto; width: 100%; overflow: auto"
                          id="rl4a"
                        >
                          <hot-table
                            :settings="{
                              licenseKey: 'non-commercial-and-evaluation',
                              data: rl4a,
                              rowHeaders: false,
                              colHeaders: false,
                              height: '400px',
                              width: '100%',
                            }"
                          ></hot-table>
                        </div>
                      </div>
                    </div>
                    <Loading v-else />
                  </b-tab>
                  <b-tab title="RL 4A - Penyebab Kecelakaan">
                    <div class="card" v-if="loadedA2">
                      <div class="card-body">
                        <div class="row mb-4">
                          <div class="col-md-9">
                            <h4 class="mt-2">
                              Formulir RL 4A Data Keadaan Morbiditas Pasien
                              Rawat Inap Rumah Sakit Penyebab Kecelakaan
                            </h4>
                          </div>
                          <div class="col-md-3 pl-3">
                            <download-excel
                              class="btn btn-default btn-primary btn-block"
                              :data="rl4a2"
                              worksheet="RL-4A.2"
                              name="rekapitulasi_laporan_4_a_2"
                            >
                              Download Excel
                            </download-excel>
                          </div>
                        </div>
                        <div
                          style="height: auto; width: 100%; overflow: auto"
                          id="rl4a2"
                        >
                          <hot-table
                            :settings="{
                              licenseKey: 'non-commercial-and-evaluation',
                              data: rl4a2,
                              rowHeaders: false,
                              colHeaders: false,
                              height: '400px',
                              width: '100%',
                            }"
                          ></hot-table>
                        </div>
                      </div>
                    </div>
                    <Loading v-else />
                  </b-tab>
                  <b-tab title="RL 4B">
                    <div class="card" v-if="loadedB1">
                      <div class="card-body">
                        <div class="row mb-4">
                          <div class="col-md-9">
                            <h4 class="mt-2">
                              Formulir RL 4B Data Keadaan Morbiditas Pasien
                              Rawat Jalan
                            </h4>
                          </div>
                          <div class="col-md-3 pl-5">
                            <download-excel
                              class="btn btn-default btn-primary btn-block"
                              :data="rl4b"
                              worksheet="RL-4B.1"
                              name="rekapitulasi_laporan_4_b_1"
                            >
                              Download Excel
                            </download-excel>
                          </div>
                        </div>
                        <div
                          style="height: auto; width: 100%; overflow: auto"
                          id="rl4b"
                        >
                          <hot-table
                            :settings="{
                              licenseKey: 'non-commercial-and-evaluation',
                              data: rl4b,
                              height: '400px',
                              width: '100%',
                              rowHeaders: false,
                              colHeaders: false,
                            }"
                          ></hot-table>
                        </div>
                      </div>
                    </div>
                    <Loading v-else />
                  </b-tab>
                  <b-tab title="RL 4B - Penyebab Kecelakaan">
                    <div class="card" v-if="loadedB2">
                      <div class="card-body">
                        <div class="row mb-4">
                          <div class="col-md-9">
                            <h4 class="mt-2">
                              Formulir RL 4B Data Keadaan Morbiditas Pasien
                              Rawat Jalan Penyebab Kecelakaan
                            </h4>
                          </div>
                          <div class="col-md-3 pl-5">
                            <download-excel
                              class="btn btn-default btn-primary btn-block"
                              :data="rl4b2"
                              worksheet="RL-4B.2"
                              name="rekapitulasi_laporan_4_b_2"
                            >
                              Download Excel
                            </download-excel>
                          </div>
                        </div>
                        <div
                          style="height: auto; width: 100%; overflow: auto"
                          id="rl4b"
                        >
                          <hot-table
                            :settings="{
                              licenseKey: 'non-commercial-and-evaluation',
                              data: rl4b2,
                              height: '400px',
                              width: '100%',
                              rowHeaders: false,
                              colHeaders: false,
                            }"
                          ></hot-table>
                        </div>
                      </div>
                    </div>
                    <Loading v-else />
                  </b-tab>
                </b-tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
// import DoughnutChart from "@/components/DoughnutChart.js";
// import BarChart from "@/components/BarChart.js";
import HorizontalBarChart from "@/components/HorizontalBarChart.js";
import Loading from "@/components/Loading.vue";
import EmptyState from "@/components/EmptyState.vue";
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRow from "@/components/FormRow.vue";
import LeftMenuRl from "@/components/LeftMenuRl.vue";
import { ageInterval, getInputDate } from "@/data/helper.js";
// import { HTTP } from "@/config.js";
import { HotTable } from "@handsontable/vue";
import { registerAllModules } from "handsontable/registry";
import "handsontable/dist/handsontable.full.css";
registerAllModules();

import {
  data,
  dataRl4,
  tabs,
  filtersRl4,
  sort,
  upperTabs,
  formattedFirstDayOfYear,
  formattedToday,
} from "@/data/Dashboard.js";
//import jQuery from 'jquery';
//import bootstrap from '@/vendor/bootstrap.js';
export default {
  name: "DashboardRl4",
  data: function() {
    return {
      fromUrl: "",
      plainUrl: "",
      loadedA1: true,
      loadedA2: true,
      loadedB1: true,
      loadedB2: true,
      data: data,
      dataHot: [
        ["", "Ford", "Volvo", "Toyota", "Honda"],
        ["2016", 10, 11, 12, 13],
        ["2017", 20, 11, 14, 13],
        ["2018", 30, 15, 12, 13],
      ],
      dataRl: dataRl4,
      upperTabs: upperTabs,
      LeftMenuRl: LeftMenuRl,
      filters: filtersRl4,
      formSet: {
        dari: formattedFirstDayOfYear,
        sampai: formattedToday,
      },
      rl4a: [],
      rl4b: [],
      rl4a2: [],
      rl4b2: [],
      combinedData: [],
    };
  },
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    LeftMenuRl,
    FormRow,
    HotTable,
    Loading,
  },
  methods: {
    handleChange(e) {
      this.formSet[e.target.name] = e.target.value;
      //console.log(this.formSet);
      // await this.displayList();
      // this.$nextTick(() => {
      //   if (this.$refs.focusMe) {
      //     this.$refs.focusMe.focus();
      //   }
      // });
      // this.apply();
    },
    displayData: async function(rl, endpoint) {
      this.errors = [];
      let len = rl.length;
      for (var i = 0; i < len; i++) {
        rl.pop();
      }
      try {
        let result = await this.$store.state.HTTP.get(endpoint);
        //console.log(result);
        if (result.status == "200") {
          Object.keys(result.data).forEach(function(key, index) {
            let content = "";
            if (!index) {
              rl.push({
                no: "No",
                title: "Jenis Kegiatan",
                content: "Jumlah",
              });
            }
            if (typeof result.data[key] !== "object") {
              content = result.data[key];
            }
            rl.push({
              no: index + 1,
              title: key
                .replace(/_/g, " ")
                .split(" ")
                .map((word) => word[0].toUpperCase() + word.slice(1))
                .join(" "),
              // key: key,
              content: content,
            });
            if (typeof result.data[key] === "object") {
              Object.keys(result.data[key]).forEach(function(innerKey) {
                let innerContent = "";
                if (typeof result.data[key][innerKey] !== "object") {
                  innerContent = result.data[key][innerKey];
                }
                rl.push({
                  title: innerKey
                    .replace(/_/g, " ")
                    .split(" ")
                    .map((word) => word[0].toUpperCase() + word.slice(1))
                    .join(" "),
                  key: innerKey,
                  content: innerContent,
                });
                if (typeof result.data[key][innerKey] === "object") {
                  Object.keys(result.data[key][innerKey]).forEach(function(
                    innerInnerKey
                  ) {
                    let innerInnerContent = "";
                    if (
                      typeof result.data[key][innerKey][innerInnerKey] !==
                      "object"
                    ) {
                      innerInnerContent =
                        result.data[key][innerKey][innerInnerKey];
                    }
                    rl.push({
                      title: innerInnerKey
                        .replace(/_/g, " ")
                        .split(" ")
                        .map((word) => word[0].toUpperCase() + word.slice(1))
                        .join(" "),
                      key: innerInnerKey,
                      content: innerInnerContent,
                    });
                  });
                }
              });
            }
            //console.log("------------------ displayData");
            //console.log(rl);
            //console.log("------------------ displayData");
          });
          ////console.log(self.formSet);
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        ////console.log(e);
        this.errors.push(e);
      }
    },
    displayDataRl4a: async function(rl, endpoint, blacklist, loadedStr) {
      this[loadedStr] = false;
      this.errors = [];
      let len = rl.length;
      for (var i = 0; i < len; i++) {
        rl.pop();
      }
      try {
        let result = await this.$store.state.HTTP.get(endpoint);
        console.log(result);

        if (result.status == "200") {
          result.data = result.data.map((item) => {
            for (const dataSet of item.data.datasets) {
              Object.keys(dataSet).forEach(function(key) {
                if (key != "labels") {
                  item[dataSet["labels"] + " " + key] = dataSet[key];
                }
              });
            }
            Object.keys(item.data).forEach(function(key) {
              if (key != "datasets") {
                item[key] = item.data[key];
              }
            });
            delete item.data;
            return item;
          });
          console.log(result.data);
          result.data.forEach((item, index) => {
            if (!index) {
              rl.push({ no: "No" });
              Object.keys(item).forEach(function(key) {
                if (typeof item[key] == "object") {
                  console.log(key);
                  Object.keys(item[key]).forEach(function(innerKey) {
                    rl[rl.length - 1][key + "_" + innerKey] = (
                      key +
                      " " +
                      innerKey
                    )
                      .replace(/_/g, " ")
                      .split(" ")
                      .map((word) => word[0].toUpperCase() + word.slice(1))
                      .join(" ");
                  });
                  delete rl[rl.length - 1][key];
                } else {
                  if (
                    !blacklist ||
                    !blacklist.length ||
                    blacklist.indexOf(key) == -1
                  ) {
                    rl[rl.length - 1][key] =
                      key == "Jenis Kegiatan"
                        ? "Jenis Kegiatan"
                        : key == "total_per_unit"
                        ? "Jumlah"
                        : key
                            .replace(/_/g, " ")
                            .split(" ")
                            .map(
                              (word) => word[0].toUpperCase() + word.slice(1)
                            )
                            .join(" ");
                  }
                }
              });
            }
            item["no"] = index + 1;
            if ("total" in item) {
              item["jenis_kegiatan"] = "TOTAL";
              item["jumlah"] = item["total"];
              item["no"] = "";
            }
            Object.keys(item).forEach(function(key) {
              if (typeof item[key] == "object") {
                Object.keys(item[key]).forEach(function(innerKey) {
                  item[key + "_" + innerKey] = item[key][innerKey];
                });
                delete item[key];
              } else {
                if (
                  blacklist &&
                  blacklist.length &&
                  blacklist.indexOf(key) > -1
                ) {
                  delete item[key];
                }
              }
            });
            rl.push({ ...item });
          });
          //console.log("-----------rl4b");
          //console.log(rl);
          //console.log("-----------rl4b");
        } else {
          this.errors.push(result.status);
        }
        this[loadedStr] = true;
      } catch (e) {
        ////console.log(e);
        this.errors.push(e);
      }
    },
    displayDataRl4b: async function(rl, endpoint, blacklist, loadedStr) {
      this[loadedStr] = false;
      this.errors = [];
      let len = rl.length;
      for (var i = 0; i < len; i++) {
        rl.pop();
      }
      try {
        let result = await this.$store.state.HTTP.get(endpoint);
        console.log(result);

        if (result.status == "200") {
          result.data = result.data.map((item) => {
            for (const dataSet of item.data.datasets) {
              Object.keys(dataSet).forEach(function(key) {
                if (key != "labels") {
                  item[dataSet["labels"] + " " + key] = dataSet[key];
                }
              });
            }
            Object.keys(item.data).forEach(function(key) {
              if (key != "datasets") {
                item[key] = item.data[key];
              }
            });
            delete item.data;
            return item;
          });
          console.log(result.data);
          result.data.forEach((item, index) => {
            if (!index) {
              rl.push({ no: "No" });
              Object.keys(item).forEach(function(key) {
                if (typeof item[key] == "object") {
                  console.log(key);
                  Object.keys(item[key]).forEach(function(innerKey) {
                    rl[rl.length - 1][key + "_" + innerKey] = (
                      key +
                      " " +
                      innerKey
                    )
                      .replace(/_/g, " ")
                      .split(" ")
                      .map((word) => word[0].toUpperCase() + word.slice(1))
                      .join(" ");
                  });
                  delete rl[rl.length - 1][key];
                } else {
                  if (
                    !blacklist ||
                    !blacklist.length ||
                    blacklist.indexOf(key) == -1
                  ) {
                    rl[rl.length - 1][key] =
                      key == "Jenis Kegiatan"
                        ? "Jenis Kegiatan"
                        : key == "total_per_unit"
                        ? "Jumlah"
                        : key
                            .replace(/_/g, " ")
                            .split(" ")
                            .map(
                              (word) => word[0].toUpperCase() + word.slice(1)
                            )
                            .join(" ");
                  }
                }
              });
            }
            item["no"] = index + 1;
            if ("total" in item) {
              item["jenis_kegiatan"] = "TOTAL";
              item["jumlah"] = item["total"];
              item["no"] = "";
            }
            Object.keys(item).forEach(function(key) {
              if (typeof item[key] == "object") {
                Object.keys(item[key]).forEach(function(innerKey) {
                  item[key + "_" + innerKey] = item[key][innerKey];
                });
                delete item[key];
              } else {
                if (
                  blacklist &&
                  blacklist.length &&
                  blacklist.indexOf(key) > -1
                ) {
                  delete item[key];
                }
              }
            });
            rl.push({ ...item });
          });
          //console.log("-----------rl4b");
          //console.log(rl);
          //console.log("-----------rl4b");
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        ////console.log(e);
        this.errors.push(e);
      }
      this[loadedStr] = true;
    },
    apply: async function() {
      // this.rl4b = [];
      this.displayDataRl4b(
        this.rl4b,
        `rekapitulasi_laporan_4b_1?dari=${this.formSet.dari}&sampai=${this.formSet.sampai}`,
        ["unit"],
        "loadedB1"
      );

      // this.rl4b = [];
      this.displayDataRl4b(
        this.rl4b2,
        `rekapitulasi_laporan_4b_2?dari=${this.formSet.dari}&sampai=${this.formSet.sampai}`,
        ["unit"],
        "loadedB2"
      );
      this.displayDataRl4a(
        this.rl4a,
        `rekapitulasi_laporan_4a_1?dari=${this.formSet.dari}&sampai=${this.formSet.sampai}`,
        "Jenis Pelayanan",
        "loadedA1"
      );

      this.displayDataRl4a(
        this.rl4a2,
        `rekapitulasi_laporan_4a_2?dari=${this.formSet.dari}&sampai=${this.formSet.sampai}`,
        "Jenis Pelayanan",
        "loadedA2"
      );
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  mounted: async function() {
    await this.apply();
  },
};
</script>
